import { CreateUtilInput } from '../models/CreateUtilInput';
import { UpdateUtilInput } from '../models/UpdateUtilInput';
import { UtilInfo } from '../models/UtilInfo';
import apiClient from 'features/common/auth/api-client';

export const getUtils = async (): Promise<UtilInfo[]> => {
  const response = await apiClient.get('utils');
  return response.data;
};

export const getPinnedUtils = async (): Promise<string[]> => {
  const response = await apiClient.get('utils/pinned');
  return response.data;
};

export const getUtil = async (id: string): Promise<UtilInfo> => {
  const response = await apiClient.get(`utils/${id}`);
  return response.data;
};

export const createUtil = async (util: CreateUtilInput): Promise<UtilInfo> => {
  const response = await apiClient.post('utils', util);
  return response.data;
};

export const updateUtil = async (id: string, util: UpdateUtilInput): Promise<UtilInfo> => {
  const response = await apiClient.put(`utils/${id}`, util);
  return response.data;
};

export const togglePinStatus = async (id: string, isPinned: boolean): Promise<UtilInfo> => {
  const response = await apiClient.put(`utils/${id}/pin-status`, { isPinned });
  return response.data;
};

export const deleteUtil = async (id: string): Promise<void> => {
  await apiClient.delete(`utils/${id}`);
};
